<div class="loader-container">
  <div class="loader">{{ 'spinner.loading' | cxTranslate }}</div>
</div>
